var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHousehold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.5C3 9.22386 3.22386 9 3.5 9H20.5C20.7761 9 21 9.22386 21 9.5V21.5C21 21.7761 20.7761 22 20.5 22H3.5C3.22386 22 3 21.7761 3 21.5V9.5Z",
    fill: "url(#paint0_linear_25516_37894)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16C10 14.8954 10.8954 14 12 14C13.1046 14 14 14.8954 14 16V22H10V16Z",
    fill: "#8E8CEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4458 2.5H6.55429C6.2095 2.5 5.88903 2.68872 5.70629 2.99938L1.47817 10.1872C1.27003 10.541 1.50945 11 1.90217 11H22.0979C22.4906 11 22.7301 10.541 22.5219 10.1872L18.2938 2.99938C18.1111 2.68872 17.7906 2.5 17.4458 2.5Z",
    fill: "url(#paint1_linear_25516_37894)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6464 8.15731L9 11H15L12.3536 8.15731C12.1583 7.94756 11.8417 7.94756 11.6464 8.15731Z",
    fill: "#E6E5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91667 14C5.68655 14 5.5 14.1865 5.5 14.4167V16.0833C5.5 16.3135 5.68655 16.5 5.91667 16.5H7.58333C7.81345 16.5 8 16.3135 8 16.0833V14.4167C8 14.1865 7.81345 14 7.58333 14H5.91667Z",
    fill: "#8E8CEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4167 14C16.1865 14 16 14.1865 16 14.4167V16.0833C16 16.3135 16.1865 16.5 16.4167 16.5H18.0833C18.3135 16.5 18.5 16.3135 18.5 16.0833V14.4167C18.5 14.1865 18.3135 14 18.0833 14H16.4167Z",
    fill: "#8E8CEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25516_37894",
    x1: 7.5,
    y1: 17.8214,
    x2: 11.5324,
    y2: 12.0899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D9D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703225,
    stopColor: "#E6E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25516_37894",
    x1: 14.2917,
    y1: 6.27778,
    x2: 15.7196,
    y2: 4.42982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B0F5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousehold);
export default __webpack_public_path__ + "static/media/household.1c975db4a29170b76fcd2533857cbbe6.svg";
export { ForwardRef as ReactComponent };